import { render, staticRenderFns } from "./BackingInformationModal.vue?vue&type=template&id=c31fd464"
import script from "./BackingInformationModal.vue?vue&type=script&lang=js"
export * from "./BackingInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports